// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pkoZizZcgbfhs51wYnep {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 24px;
  gap: 32px;
  border-radius: 14px;
  border: 1px solid var(--grey-color-300);
  background-color: #f8f8f8;
}

.c1omAL4kJQoFdztdOP74 {
  padding-right: 24px;
  width: 50%;
}

.m5hrVI0M8BqteguGiRim {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  padding-bottom: 4px;
}

.JVxRkOc2HNh0xnscRg_n:hover {
  background-color: var(--grey-color-10);
}

.uMjdriZqlRDTIQbNYZrn {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 16px;
}

.l5PIbu300EOGPmUGCMYG {
  width: 644px;
  display: flex;
  flex-direction: column;
}

.ZXcHmqycZ0YUDdmdwE25 {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  padding-bottom: 8px;
}

.SGd90ksIoVFZPzapFh7a {
  border-radius: 16px;
  margin-top: 2px;
  box-shadow: 0px 4px 16px rgba(15, 20, 31, 0.1215686275);
  width: 644px;
}

.DRbvzcqCshedDBPQ7E3t {
  margin-bottom: 16px;
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  line-height: 24px;
  color: var(--grey-color-60);
}

.bFs0aVqIwGtG1w_f6rVS {
  display: flex;
  gap: 24px;
}

.x9Wt2LAeuUooTmih5Es7 {
  font-family: var(--font-stack-full-heavy);
  font-size: 24px;
  line-height: 32px;
  color: var(--grey-color-90);
}

.DUFg4eMaJ3Tx8GMMHCoR {
  margin: 24px 0;
}

.Uqv2Z7CXS7NOaBljk0PA {
  display: flex;
  gap: 19px;
  margin-bottom: 16px;
}

.LmL5FWL76bJPoPO0a6BQ {
  margin-bottom: 8px;
}

.qTQYRc_9LZgtNPOJ87Ss {
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  color: var(--grey-color-90);
}

.mbO0ZoxbZAKj5PlwWgsd {
  margin: 0;
  font-family: var(--font-stack-full-heavy);
  font-weight: 800;
  font-size: 20px;
  line-height: 28px;
  color: var(--grey-color-90);
}

.a3TdwEneMlcPlQ_0c8o6 {
  margin: 0;
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  line-height: 24px;
  color: var(--grey-color-60);
}

.JupsEAhLEJ5m_IOZ19Ly {
  margin-bottom: 8px;
}

.tCagcztrthYEaFtN1sUq {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Vwtlkj9xXVsbjY7mIiuz {
  padding: 8px;
  cursor: pointer;
}

.HGwhKBDpYclN9kIXV5DE {
  font-family: var(--font-stack-full-heavy);
  font-size: 24px;
  font-weight: 800;
  line-height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SuccessProfiles/SuccessProfilePage.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uCAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,2BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,uDAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,SAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACF","sourcesContent":[".roleBasedContainer {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  padding: 24px;\n  gap: 32px;\n  border-radius: 14px;\n  border: 1px solid var(--grey-color-300);\n  background-color: #f8f8f8;\n}\n\n.roleSpecificContentContainer {\n  padding-right: 24px;\n  width: 50%;\n}\n\n.roleSpecificLabel {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  padding-bottom: 4px;\n}\n\n.roleOption:hover {\n  background-color: var(--grey-color-10);\n}\n\n.roleSpecificDescription {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n}\n\n.searchFilterLabelContainer {\n  width: 644px;\n  display: flex;\n  flex-direction: column;\n}\n\n.searchFilterLabel {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  padding-bottom: 8px;\n}\n\n.autocompleteSearchPaper {\n  border-radius: 16px;\n  margin-top: 2px;\n  box-shadow: 0px 4px 16px #0f141f1f;\n  width: 644px;\n}\n\n.successProfileMainContent {\n  margin-bottom: 16px;\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--grey-color-60);\n}\n\n.successProfileImageAndContent {\n  display: flex;\n  gap: 24px;\n}\n\n.successProfileSecondContent {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 24px;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.successProfilesPopupDividerWrapper {\n  margin: 24px 0;\n}\n\n.successProfilesPopuplastcontainer {\n  display: flex;\n  gap: 19px;\n  margin-bottom: 16px;\n}\n\n.successProfilePopupLastBoxes {\n  margin-bottom: 8px;\n}\n\n.successProfilesFunctionalImpact {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 24px;\n  color: var(--grey-color-90);\n}\n\n.successProfileHeaderContentBox {\n  margin: 0;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 800;\n  font-size: 20px;\n  line-height: 28px;\n  color: var(--grey-color-90);\n}\n\n.successProfileParagraphContentBox {\n  margin: 0;\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--grey-color-60);\n}\n\n.chevronImagesStyle {\n  margin-bottom: 8px;\n}\n\n.successProfilesInfoIconContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.successProfilesInfoIcon {\n  padding: 8px;\n  cursor: pointer;\n}\n\n.successProfileTitle {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roleBasedContainer": `pkoZizZcgbfhs51wYnep`,
	"roleSpecificContentContainer": `c1omAL4kJQoFdztdOP74`,
	"roleSpecificLabel": `m5hrVI0M8BqteguGiRim`,
	"roleOption": `JVxRkOc2HNh0xnscRg_n`,
	"roleSpecificDescription": `uMjdriZqlRDTIQbNYZrn`,
	"searchFilterLabelContainer": `l5PIbu300EOGPmUGCMYG`,
	"searchFilterLabel": `ZXcHmqycZ0YUDdmdwE25`,
	"autocompleteSearchPaper": `SGd90ksIoVFZPzapFh7a`,
	"successProfileMainContent": `DRbvzcqCshedDBPQ7E3t`,
	"successProfileImageAndContent": `bFs0aVqIwGtG1w_f6rVS`,
	"successProfileSecondContent": `x9Wt2LAeuUooTmih5Es7`,
	"successProfilesPopupDividerWrapper": `DUFg4eMaJ3Tx8GMMHCoR`,
	"successProfilesPopuplastcontainer": `Uqv2Z7CXS7NOaBljk0PA`,
	"successProfilePopupLastBoxes": `LmL5FWL76bJPoPO0a6BQ`,
	"successProfilesFunctionalImpact": `qTQYRc_9LZgtNPOJ87Ss`,
	"successProfileHeaderContentBox": `mbO0ZoxbZAKj5PlwWgsd`,
	"successProfileParagraphContentBox": `a3TdwEneMlcPlQ_0c8o6`,
	"chevronImagesStyle": `JupsEAhLEJ5m_IOZ19Ly`,
	"successProfilesInfoIconContainer": `tCagcztrthYEaFtN1sUq`,
	"successProfilesInfoIcon": `Vwtlkj9xXVsbjY7mIiuz`,
	"successProfileTitle": `HGwhKBDpYclN9kIXV5DE`
};
export default ___CSS_LOADER_EXPORT___;
